import { ENABLE_BUTTON_SUBMIT_ACTION_NAME } from "../constants";

const SUBMIT_BUTTON_CLASSNAME = "js-submit-button";
const FORM_ACTION_BUTTON_CLASSNAME = "js-form-action-button";
const CLICK_ONCE_LINK_CLASSNAME = "js-click-once-link";

class SingleClickButtons {
  static submitButtonClassName = SUBMIT_BUTTON_CLASSNAME;

  static enableButtonSubmit() {
    const $submitButtons = document.querySelectorAll(`.${SUBMIT_BUTTON_CLASSNAME}`);
    if ($submitButtons.length > 0) {
      window.dispatchEvent(new CustomEvent(ENABLE_BUTTON_SUBMIT_ACTION_NAME));
    }
  }

  static enableDisableAllActionButtons(setDisable = true) {
    const $formActionButtons = document.querySelectorAll(`.${FORM_ACTION_BUTTON_CLASSNAME}`);
    [...$formActionButtons].forEach(($formActionButton) => {
      if (setDisable) {
        $formActionButton.setAttribute("disabled", `${setDisable}`);
      } else {
        $formActionButton.removeAttribute("disabled");
      }
    });
  }

  static disableButtonMultipleSubmit() {
    const $submitButtons = document.querySelectorAll(`.${SUBMIT_BUTTON_CLASSNAME}`);
    [...$submitButtons].forEach(($submitButton) => {
      const $parentForm = $submitButton.closest("form");
      const { isAjaxForm } = $parentForm.dataset;
      $submitButton.addEventListener("click", () => {
        $parentForm.addEventListener("submit", () => {
          setTimeout(() => {
            this.enableDisableAllActionButtons();
          }, 0);
        });
        if (isAjaxForm) {
          this.enableDisableAllActionButtons();
          $parentForm.dispatchEvent(new SubmitEvent("submit", { submitter: $submitButton }));
        }
      });
    });

    window.addEventListener(ENABLE_BUTTON_SUBMIT_ACTION_NAME, () => {
      SingleClickButtons.enableDisableAllActionButtons(false);
    });
  }

  static disableLinkMultipleClick() {
    const $clickOnceLinks = document.querySelectorAll(`.${CLICK_ONCE_LINK_CLASSNAME}`);
    [...$clickOnceLinks].forEach(($clickOnceLink) => {
      $clickOnceLink.addEventListener("click", () => {
        setTimeout(() => {
          $clickOnceLink.classList.add("disabled");
          $clickOnceLink.setAttribute("href", "#");
          $clickOnceLink.setAttribute("onclick", "return false;");
        }, 0);
      });
    });
  }
}

export { SingleClickButtons };
